<template>
  <v-card class="schedule pa-4">
    <loader :loading="loading" />
    <div v-if="!loading">
      <div v-if="!date" class="schedule__mainHeader">
        <a href="#" class="schedule__link schedule__link--left" @click.prevent="previousWeek">
          <i class="icon fontello-arrow-left"></i>
          <span class="no-space">Пред<span class="mobile">ыдущая</span></span>
          неделя
        </a>

        <h2 class="schedule__title">
          <template v-if="weekInfo.month_start === weekInfo.month_end">
            {{ weekInfo.day_start }} – {{ weekInfo.day_end }} {{ weekInfo.month_start }} {{ weekInfo.year_end }}
          </template>

          <template v-if="weekInfo.month_start !== weekInfo.month_end">
            {{ weekInfo.day_start }} {{ weekInfo.month_start }}
            <template v-if="weekInfo.year_start !== weekInfo.year_end">{{ weekInfo.year_start }}</template>
            – {{ weekInfo.day_end }} {{ weekInfo.month_end }} {{ weekInfo.year_end }}
          </template>
        </h2>

        <a href="#" class="schedule__link schedule__link--right" @click.prevent="nextWeek">
          <span class="no-space">След<span class="mobile">ующая</span></span>
          неделя
          <i class="icon fontello-arrow-right"></i>
        </a>
      </div>
      <div v-else class="schedule__mainHeader">
        <h2 class="schedule__title">Добавить запись на {{ $date(date).format("DD MMMM YYYY") }}</h2>
      </div>
      <div v-if="allowSelectOtherDoctors" class="mb-4">
        <v-select
          label="Доктор"
          v-model="currentDoctor"
          item-value="id"
          item-text="selectText"
          return-object
          :items="doctorsList"
          @change="loadData($event.id)"
        ></v-select>
      </div>
      <div>
        <div v-for="(schedule, idate) in schedules" :key="`schedule-${idate}`" class="mb-5">
          <div class="mb-2">
            <strong>{{ date ? "Время записи" : idate }}</strong>
          </div>
          <div v-if="schedule && schedule.items && schedule.items.length" class="row">
            <div class="col col-auto" v-for="item in schedule.items" :key="`schedule-${idate}-${item.ts}`">
              <v-btn v-if="item.disable" disabled>
                {{ item.time }}
              </v-btn>
              <ScheduleTimeButton
                v-else
                :doctor="currentDoctor"
                :time="item"
                :event-id="taskEventId"
                @update="onScheduleTimeUpdate(item)"
              />
            </div>
          </div>
          <div v-else><h2>Доступного времени для записи нет</h2></div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { ScheduleRepository } from "@/modules/schedule/schedule.repository.js";
import { Doctor } from "@/modules/doctors/Doctor.js";
import ScheduleTimeButton from "@/modules/schedule/ScheduleTimeButton.vue";
import Loader from "@/components/Loader";
import { DoctorsRepository } from "@/modules/doctors/doctors.repository.js";

export default {
  name: "Schedule",
  components: { ScheduleTimeButton, Loader },

  props: {
    doctor: {
      type: Doctor,
      required: true,
    },
    date: {
      type: String,
      default: "",
    },
    allowSelectOtherDoctors: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      schedules: [],
      week: 0,
      weekType: "",
      weekInfo: "",
      doctorsList: [],
      currentDoctor: this.doctor,
      // timeIntervals: [],
    };
  },

  computed: {
    taskEventId() {
      return this.$route ? this.$route.query.eventId ?? null : null;
    },
  },

  async created() {
    if (this.allowSelectOtherDoctors) {
      const list = await DoctorsRepository.getAll();
      this.doctorsList = list.map(el => {
        el.selectText =
          el.fullName +
          el.specializations.reduce(
            (accumulator, currentValue) => accumulator + ", " + currentValue.localization.specialization_doctor_name,
            " ",
          );
        return el;
      });
    }
    await this.loadData(this.doctor.id);
  },

  methods: {
    async loadData(doctor_id) {
      this.loading = true;

      const response = await ScheduleRepository.getCalendar(doctor_id, {
        week: this.week,
        weekType: this.weekType,
        date: this.date || null,
      });
      console.log(`response =>`, response);

      if (!response) {
        this.$dialog.notify.error("ошибка получения данных календаря");
        return;
      }
      if (this.date) {
        const key = this.$date(this.date).format("DD.MM.YYYY");
        this.schedules = { [key]: response.schedules[key] };
      } else {
        this.schedules = response.schedules;
      }
      this.week = response.week;
      this.weekInfo = response.weekInfo;
      // this.timeIntervals = response.time_intervals;
      this.loading = false;
    },

    previousWeek() {
      this.weekType = "prev-week";
      this.loadData(this.currentDoctor.id);
    },

    nextWeek() {
      this.weekType = "next-week";
      this.loadData(this.currentDoctor.id);
    },

    // TODO: тут плохо очень сделано, нужно точечно обновить данные
    async onScheduleTimeUpdate(item) {
      this.loadData(this.currentDoctor.id);
    },
  },
};
</script>

<style scoped lang="scss">
.schedule {
  user-select: none;
}

.schedule__mainHeader {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-align: baseline;
  align-items: baseline;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 25px;
}

.schedule__header {
  padding-left: 50px;
  margin-bottom: 10px;
}

.schedule__column,
.schedule__time {
  display: inline-block;
  vertical-align: top;
}

.schedule__column {
  width: 14.28%;
  padding: 0 2px;
}

.schedule__date {
  font-size: 14px;
  text-align: center;
}

.schedule__aside {
  width: 50px;
  float: left;
}

.schedule__time {
  width: 100%;
  height: 22px;
  margin: 2px 0;
  font-size: 14px;
  line-height: 22px;
}

.schedule__body {
  float: left;
  width: calc(100% - 50px);
}

.schedule__content:after {
  content: " ";
  display: block;
  clear: both;
  overflow: hidden;
}

.schedule__column {
  width: 14.28%;
  padding: 0 2px;
}

.schedule__cell {
  display: inline-block;
  vertical-align: top;
  width: 100%;
  height: 22px;
  margin: 2px 0;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.1s ease;
}

.schedule__cell--disable {
  opacity: 0.4;
  pointer-events: none;
}

.schedule__cell--selected {
  background-color: #e3eff8;
  border-color: #e3eff8;
}
</style>
